export function parseJson<T> (data: string | null | undefined): T | null {
  if (!data) return null

  try {
    const parsed = JSON.parse(data) as T
    return parsed
  }
  catch (e) {
    console.error('Ошибка парсинга JSON:', e)
    return null
  }
}
